// eslint-disable-next-line import/no-cycle
import {
  onsAxiosTimeoutErrorAlert,
  onsForbiddenOrConnectionErrorAlert,
  onsAlert,
  onsUnexpectedErrorAlert,
  onsClientConnectionErrorAlert,
} from '@/composable/onsen_common';
import { HTTP_RESPONSE_CODE } from '@/composable/constant_common';

/**
 * 通信前ネットワーク状態確認
 * ネットワークがオフラインの場合はクライアントの回線断エラーハンドリングを行い
 * Promiseをrejectする
 */
export function checkNetwork() {
  return new Promise((resolve, reject) => {
    if (!navigator.onLine) {
      onsClientConnectionErrorAlert();
      reject();
    } else {
      resolve();
    }
  });
}
/**
 * Axios共通例外ハンドリング処理
 * Forbidden(403), サーバ接続不可(502,503)エラー, Service Unavailable(504),
 * Axiosタイムアウト, クライアント回線断, それ以外のエラーについて
 * 後続のエラーメッセージ表示関数をCallする
 * @param error エラー情報
 */
export function handleAxiosCommonException(error, callback = () => {}) {
  // onsAlertで処理するエラーのHTTPレスポンスコード一覧
  const ERROR_ALERT_STATUS_CODES = [HTTP_RESPONSE_CODE.BAD_REQUEST, HTTP_RESPONSE_CODE.NOT_FOUND];

  if (navigator.onLine) {
    if (error.code === 'ECONNABORTED') {
      // Axiosタイムアウトでリクエストをキャンセルした場合
      onsAxiosTimeoutErrorAlert(callback);
    } else if (error.code === 'ERR_NETWORK') {
      // システムメンテナンス等によるサーバ接続不可時(403,502,503,504)エラーハンドリング
      // 想定パターン：トークン失効時, システムメンテナンス時, サーバ処理逼迫時
      onsForbiddenOrConnectionErrorAlert();
    } else if (error.response && ERROR_ALERT_STATUS_CODES.includes(error.response.status)) {
      // サーバ内部エラー(400,404)ハンドリング
      onsAlert(error.response.data.message);
    } else {
      // 上記処理例外のパターン
      onsUnexpectedErrorAlert();
    }
  } else {
    // クライアントの回線断エラーハンドリング
    onsClientConnectionErrorAlert();
  }
}

/**
 * JWTトークン変換処理
 * 引数のJWTトークンをJSON形式にデコードする
 */
export function decodeJwtToJson(Jwtbody) {
  const base64Url = Jwtbody.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  // window.atobを使用してbase64をデコードし、decodeURIComponentを使ってURLエンコードされた部分をデコード
  const jsonString = window.atob(base64);

  // JSON.parseを使って文字列をオブジェクトに変換
  // 既存のescape関数はVue3移行時に非推奨となったため、推奨の関数で代替
  return JSON.parse(decodeURIComponent(encodeURIComponent(jsonString)));
}

/**
 * イベントキャンセル
 */
export function eventCancel(event) {
  event.preventDefault();
}

/**
 * スクロールを無効にする
 */
export function disableScroll() {
  document.addEventListener('touchmove', eventCancel, { passive: false });
}

/**
 * スクロールを有効にする
 */
export function enableScroll() {
  document.removeEventListener('touchmove', eventCancel, { passive: false });
}

/**
 * 戻るボタン,<ボタン押下時処理
 */
export function moveBackButton(router) {
  router.back();
}

/**
 * スマートフォン判定処理
 */
export function isSmartPhone() {
  const regExp = /iPhone|Android.+Mobile/;
  return regExp.test(navigator.userAgent);
}

/**
 * uuid発行処理
 */
export function createUuid() {
  return crypto.randomUUID().replace(/-/g, 'h');
}

/**
 * 引数として渡された拡張子で画像か動画かを判定して返す.
 *
 * @param {string} fileExtension ファイル拡張子文字列
 * @return {boolean} 動画判定結果
 */
export function isMovieExtension(fileExtension) {
  const movieExtensionList = ['mp4', 'mov'];
  return movieExtensionList.includes(fileExtension.toLowerCase());
}

/**
 * 現在時刻を取得する処理(YYYYMMDDhhmmss形式)
 */
export function getCurrentTime() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  const formattedDateTime = `${year}${month}${day}${hours}${minutes}${seconds}`;

  return formattedDateTime;
}
